import ApiService from '../../service/apiServiceMasterProject.js';

const querystring = require('querystring')
var TimeSheetExceptionService = {

    findAll: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "timesheetexception"
            $options.method = "get"
            if ($data) {
                $options.url = "timesheetexception?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },

    update: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.data = $data
            $options.url = "timesheetexception/" + $data.id;
            $options.method = "post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
        })
    },

    timeSheetHuddleUsers: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "timeSheetHuddleUsers"
            $options.method = "get"
            if ($data) {
                $options.url = "timeSheetHuddleUsers?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },

    timeSheetExceptionUsers: function($data) {
        return new Promise(function(resolve, reject) {
            let $options = {};
            $options.url = "timesheetexceptionUsers"
            $options.method = "get"
            if ($data) {
                $options.url = "timesheetexceptionUsers?" + querystring.stringify($data)
                console.log($options.url)
            }
            ApiService.request($options)
            .then(response => {
                console.log('test');
                resolve(response.data.data)
            }).catch(error => {
                reject(error);
            })
        });
    },

    
};
export default TimeSheetExceptionService;